import { Box, Grid, Typography } from "@mui/material";

export function ProductImage({ src }) {
  if (!src) return null;
  return (
    <Box
      component="img"
      src={src}
      alt=""
      sx={{
        width: 48,
        height: 48,
        borderRadius: "8px",
        objectFit: "cover",
        flexShrink: 0,
      }}
    />
  );
}

export function ProductTitle(props) {
  return (
    <>
      <Grid item xs={12} md={6} display="flex" alignItems="center" gap="12px">
        <ProductImage src={props.item.image_url} />
        <Box minWidth={0}>
          <Typography>{props.item.title}</Typography>
          {props.item.variant_title && (
            <Typography sx={{ fontSize: "13px" }}>
              <b>{props.title}</b> {props.item.variant_title}
            </Typography>
          )}
          <Typography fontSize="13px" color="#423E56">
            ${props.item.price}
          </Typography>
        </Box>
      </Grid>
    </>
  );
}
